import { deleteApi, getApi, putApi } from "./general.service";

/**
 * Actualización parcial de un ítem del catálogo (deck o text).
 * @param {Object} params - { _id, type: 'deck'|'text', category?, subCategory? }
 */
export const updateCatalogItem = async (params) => {
    return putApi("/admin/catalog/item", params);
};

export const deleteCatalogItem = async (params) => {
    const { _id, type } = params;
    if (!_id || !type) throw new Error('deleteCatalogItem requires _id (sourceId) and type');
    const response = await deleteApi(
        `/admin/catalog/item?_id=${encodeURIComponent(_id)}&type=${encodeURIComponent(type)}`,
        params
    );
    if (response?.response?.status >= 400) {
        throw response;
    }
    if (!response || typeof response.status !== "number" || response.status >= 400) {
        throw new Error("Catalog delete request failed");
    }
    return response;
};

export const getCatalog = async (params) => {
    try {
        // params: { page, take, search (title), type, categoryId, etc. }
        // Mapeamos 'search' a 'title' porque CatalogFilterDto usa 'title' para búsqueda de texto
        const raw = {
            ...params,
            title: params.search || params.title,
            isBackoffice: true,
        };
        delete raw.search;

        // Remove undefined/null so axios doesn't send them (type=all → omit type param for backend)
        const queryParams = Object.fromEntries(
            Object.entries(raw).filter(([, v]) => v !== undefined && v !== null)
        );

        const response = await getApi("/catalog", {
            params: queryParams
        });
        return response;
    } catch (error) {
        throw error;
    }
};
